import { useFieldContext } from "@/features/question/components/organisms/FieldRenderer";
import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";

export function TextRenderer() {
    const { question, setFormValue, disabled, response, currentValue } = useFieldContext();
    const [value, setValue] = useState<string>("");
    const { field_max: max_length } = question;

    useEffect(() => {
        if(currentValue) {
            setValue(currentValue);
        }
    }, [currentValue]);

    if (disabled) {
        return (
            <div className="">
                <p className="whitespace-pre">{response.field_value}</p>
            </div>
        )
    } else {
        return (
            <div className="flex flex-col gap-2">
                <Input
                    type="text"
                    onChange={(e) => {
                        const value = e.target.value;
                        setValue(value);
                        setFormValue(value);
                    }}
                    maxLength={max_length ?? undefined}
                    value={value}
                />
                {max_length && <p className="[font-size:12px]">{value.split('').length}/{max_length}</p>}

            </div>
        )
    }

}
